import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { translationActions } from '../../helper/translationHelpers';
import { translationStore } from '../../stores/TranslationStore';
const TranslationStats = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    translationData
  } = translationStore;
  const {
    sourceLanguageKey,
    targetLanguageKey
  } = translationData;
  let unchangedTranslations = 0;
  let translationsWithoutConflict = 0;
  let conflictsInSourceLanguage = 0;
  let conflictsInTargetLanguage = 0;
  let translationsForDeletedElements = 0;

  for (const {
    stillExists,
    translationsByGender
  } of translationData.translations) {
    for (const {
      targetLanguageStringChanged,
      sourceLanguageStringChanged,
      currentTargetLanguageString,
      importTargetLanguageString
    } of translationsByGender.values()) {
      if (targetLanguageStringChanged) {
        if (stillExists) {
          if (sourceLanguageStringChanged) {
            conflictsInSourceLanguage++;
          }

          const targetLanguageConflict = targetLanguageStringChanged && Boolean(currentTargetLanguageString);

          if (targetLanguageConflict) {
            conflictsInTargetLanguage++;
          }

          if (!sourceLanguageStringChanged && !targetLanguageConflict) {
            translationsWithoutConflict++;
          }
        } else {
          translationsForDeletedElements++;
        }
      } else if (importTargetLanguageString) {
        unchangedTranslations++;
      }
    }
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, t("translation.stats_new_texts"), ": ", translationsWithoutConflict + conflictsInSourceLanguage + conflictsInTargetLanguage), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, t("translation.stats_without_conflict"), ": ", translationsWithoutConflict), /*#__PURE__*/React.createElement("li", null, t("translation.stats_conflict_in_source_language", {
    sourceLanguage: t("translation.language_" + sourceLanguageKey)
  }), ": ", conflictsInSourceLanguage), /*#__PURE__*/React.createElement("li", null, t("translation.stats_conflict_in_target_language"), " ", t("translation.language_" + targetLanguageKey), ": ", conflictsInTargetLanguage)), /*#__PURE__*/React.createElement("li", null, t("translation.stats_filled_but_unchanged_texts"), ": ", unchangedTranslations), /*#__PURE__*/React.createElement("li", null, t("translation.stats_translations_for_deleted_entities"), ": ", translationsForDeletedElements), /*#__PURE__*/React.createElement("li", null, t("translation.stats_actions"), ":"));
});
const ActionStats = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    actionCount
  } = translationStore;
  return /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("ul", null, translationActions.map(action => /*#__PURE__*/React.createElement("li", {
    key: action
  }, t("translation.action_" + action), ": ", actionCount.get(action)))));
});
export const TranslationDataStatsDisplay = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(TranslationStats, null), /*#__PURE__*/React.createElement(ActionStats, null)));
};